import {Card, CardContent, CardHeader, CardTitle} from '@orbit-ui/components/card';
import {PageHeader} from '@orbit-ui/components/page-header';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@orbit-ui/components/table';

export const TenantsActivityView = () => {
  const activities = [
    {
      id: 1,
      tenant: 'Acme Corp',
      action: 'User Added',
      details: 'Added user john.doe@acme.com',
      timestamp: '2025-03-31 16:42:00',
    },
    {
      id: 2,
      tenant: 'TechStar',
      action: 'Resource Allocated',
      details: 'Increased storage to 500GB',
      timestamp: '2025-03-31 13:22:00',
    },
    {
      id: 3,
      tenant: 'Global Services',
      action: 'Status Changed',
      details: 'Changed from Active to Inactive',
      timestamp: '2025-03-31 09:15:00',
    },
    {
      id: 4,
      tenant: 'Acme Corp',
      action: 'Component Deployed',
      details: 'Deployed API Gateway v2.3',
      timestamp: '2025-03-30 17:30:00',
    },
  ];

  return (
    <div className="container mx-auto space-y-6 py-6">
      <PageHeader title="Tenants Activity" description="Recent tenant activities and events" />

      <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Tenant</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Details</TableHead>
                <TableHead>Timestamp</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {activities.map((activity) => (
                <TableRow key={activity.id}>
                  <TableCell className="font-medium">{activity.tenant}</TableCell>
                  <TableCell>{activity.action}</TableCell>
                  <TableCell>{activity.details}</TableCell>
                  <TableCell>{activity.timestamp}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};
